/*=========================================================================================
  File Name: moduleSchedule.js
  Description: Schedule Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleTimeWindowState.js";
import mutations from "./moduleTimeWindowMutations.js";
import actions from "./moduleTimeWindowActions.js";
import getters from "./moduleTimeWindowGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
